define('models/NewsModel',['underscore','app','ObjectModel','LocalStorage','moment','UrlFactory'],function (_,app,ObjectModel,LocalStorage,moment,UrlFactory) {
    //
    // Model News
    //
    var NewsModelPrototype = {
        
        name:'NewsModel',
        idAttribute:'id_news',
        route:'apiNewsModel',
        
        initialize:function(){
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(this,arguments);
            //
            if(!this.get(this.idAttribute)){
                this.attributes[this.idAttribute] = this.get('id');
            }
        },
        getDate:function(){
            var date_display = this.get('date_display')

            if (!date_display) {return false}
            return moment(this.get('date_display'))
        },
        getName:function(){return this.get('name')},
        getTitle:function(){return this.get('title')},
        getDescriptionShort:function(){return this.get('description_short')},
        getDescription:function(){return this.get('description')},
        getDateAddMoment:function(){return moment(this.get('date_add'))},
        isNews:function(){
            return this.get('is_news');
        },
        hasCTA:function(){
            var model = this;
            return !!model.get('cta_link')&&!!model.get('cta_text');
        },
        getPictureUrl:function(source, format){

            // sujet tricky lié à l'historique des contenus actualités (v1, app, etc.)
            source = source || 'image_banner';
            format = format || '1280x720';

            var    url = app.getPictureUrl(this.get(source),'News',format,'JPG',this.getTitle());
            return url;
        },
        getUrl:function(){
            return UrlFactory.getUrl('newsSingle',{url_rewrite:this.get('link_rewrite')})
        },
        getDefaultFlag:function(){
            var id_news_flag = this.get('id_default_tag');
            return app.getNewsFlag(id_news_flag);
        },
        getDefaultFlagName:function(){
            var defaultFlag = this.getDefaultFlag();
            if(defaultFlag) return defaultFlag.getName();
        },
        getDefaultFlagUrl:function(){
            var defaultFlag = this.getDefaultFlag();
            if(defaultFlag) return defaultFlag.getUrl();
        }
    };

    var NewsModel = ObjectModel.extend(LocalStorage).extend(NewsModelPrototype);
    
    return NewsModel;
});
